import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';
import UnifiedSignupPersona from '../session-info/UnifiedSignupPersona';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupGradeLevel from '../session-info/UnifiedSignupGradeLevel';
import UnifiedSignupPersonaDetails from '../session-info/UnifiedSignupPersonaDetails';

export default class PersonaEduIntentSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-persona-edu-intent';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    const ageVerificationField = this.getField(FieldHtmlNameUtil.ageVerification);
    ageVerificationField.componentName = 'hidden-field';
    ageVerificationField.val = 'overage';
    return [
      new UnifiedSignupScreenComponent({
        displayField: ageVerificationField,
      }),
    ];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.whatIsYourExperience),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.eduLevel),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.ageVerification),
      }),
    ];
  }

  /** Show this screen if we have checked email but don't know the users intent */
  public predicate(): boolean {
    return (
      (this.isOkEmailOrEdu() || this.isOkEmailOrPro()) &&
      this.sessionInfo.value.intent !== null &&
      this.sessionInfo.value.intent.compareTo(UnifiedSignupIntent.eduIntent) &&
      this.sessionInfo.value.persona === null &&
      !this.sessionInfo.value.isUnderThirteen
    );
  }

  public async toNextScreen(): Promise<boolean> {
    const persona = this.getField(FieldHtmlNameUtil.whatIsYourExperience).val;
    this.sessionInfo.value.persona = UnifiedSignupPersona.fromString(persona);
    const personaDetails = this.getField(FieldHtmlNameUtil.personaDetail).val;
    this.sessionInfo.value.personaDetails = UnifiedSignupPersonaDetails.fromString(personaDetails);
    const gradeLevel = this.getField(FieldHtmlNameUtil.eduLevel).val;
    this.sessionInfo.value.gradeLevel = UnifiedSignupGradeLevel.fromString(gradeLevel);
    const underAgeVerification = this.getField(FieldHtmlNameUtil.ageVerification).val;
    this.sessionInfo.value.isUnderThirteen = underAgeVerification === 'underage';
    return true;
  }

  public getProgress(): number {
    return 30;
  }
}
